import api from '~/api/api'

export const RealEstateInquiryApi = {
  send: (data: FormData) => api('/real-estate/inquiry', data, 'POST'),
}

export const VibeRealEstate = {
  getByVibe: (vibeId: number) => api('/vibe-real-estate/index', { vibeId }),
}

export const RealEstateProject = {
  getList: (params: Record<string, any> = {}) => api('/real-estate/projects/index', params),
  getOne: (id: number) => api('/real-estate/projects/info', { id }),
  getObjectsByProject: (projectId: number) => api('/real-estate/index', { projectId, limit: 50 }),
  getInfraByProject: (projectId: number) => api('/real-estate/infrastructure/index', { projectId }),
}

export const RealEstateObject = {
  getOne: (id: number) => api('/real-estate/info', { id }),
  getPublished: (params: Record<string, any> = {}) =>
    api('/real-estate/index', { status: 'published', limit: 50, ...params }),
  getByProject: (projectId: number, params: Record<string, any> = {}) =>
    api('/real-estate/index', { projectId, status: 'published', limit: 12, ...params }),
}
